export default class Collapsible {
    constructor(element, options) {
        this.el = element;
        this.init(options);
    }

    defaults() {
        let obj = this;

        return {
            scrollIntoView: true,
            showHidden: true,
            buttons: [],
            hidden: ['hidden'],
            readMoreText: 'Read More',
            readLessText: 'Read Less',
            events: {
                onInitialized: function () {},
                beforeHidden: function () {},
                hidden: function () {},
                beforeVisible: function () {},
                visible: function () {},
            },
        };
    }

    data() {
        let obj = this;

        obj.data = {
            isHidden: obj.settings.showHidden,
            events: {
                onInitialized: [obj.onInitialized, obj.settings.events.onInitialized],
                beforeHidden: [obj.beforeHidden, obj.settings.events.beforeHidden],
                hidden: [obj.onHidden, obj.settings.events.hidden],
                visible: [obj.onVisible, obj.settings.events.visible],
            },
        };
    }

    init(options) {
        let obj = this;
        obj.settings = Object.assign({}, obj.defaults(), options);

        let stickyButton = obj.settings.buttons.find(button => button.settings.isSticky == true );

        obj.settings.stickyButton = stickyButton;

        obj.data();
        obj.wrapIntoAContainer();
        obj.buttonCreateIfNotExists();
        obj.buttonState();
        obj.listeners();

        $(obj.el).trigger('collapsible.initialized', obj);
    }

    wrapIntoAContainer() {
        let obj = this;
        $(obj.el).wrap($('<div/>').addClass('collapsible-container')[0].outerHTML);
        return obj;
    }

    buttonCreateIfNotExists() {
        let obj = this;

        if (obj.settings.buttons.length === 0) {
            let id = Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000;

            let button = $('<button />')
                .addClass('btn-gradient')
                .attr({
                    'data-collapse-hidden':
                        obj.settings.readMoreText + " <svg xmlns='http://www.w3.org/2000/svg' width='17' height='17' viewBox='0 0 17 17'><path fill='#000' d='M 0 5.191406 L 2.003906 3.1875 L 8.503906 9.800781 L 14.996094 3.1875 L 17 5.191406 L 8.503906 13.8125 Z M 0 5.191406'/></svg>",
                    'data-collapse-visible':
                        obj.settings.readLessText + " <svg xmlns='http://www.w3.org/2000/svg' width='17' height='17' viewBox='0 0 17 17'><path fill='#000' d='M 0 11.808594 L 2.003906 13.8125 L 8.503906 7.199219 L 14.996094 13.8125 L 17 11.808594 L 8.503906 3.1875 Z M 0 11.808594'/></svg>",
                    id: 'collapsible-button-' + id,
                });

            $('div.collapsible-container').append(button[0].outerHTML);

            button = $('button#collapsible-button-' + id);

            obj.addNewButton(new CollapsibleButton(button[0]));
        }
    }

    addNewButton(button) {
        let obj = this;
        if (button instanceof CollapsibleButton) {
            obj.settings.buttons.push(button);
        }
        return obj;
    }

    buttonState() {
        let obj = this;

        obj.settings.buttons.forEach(function (button) {
            if (button instanceof CollapsibleButton) {
                button.setState(obj.data.isHidden).setLabel();
            }
        });
    }

    listeners() {
        let obj = this;

        obj.listenersButtons()
            .listenersInit()
            .listenersBeforeHidden()
            .listenersHidden()
            .listenersVisible()
            .listenersScroll();
    }

    listenersInit() {
        let obj = this;

        $(obj.el).on('collapsible.initialized', function () {
            obj.data.events.onInitialized.forEach(function (callback) {
                if (typeof callback === 'function') {
                    callback.call(obj);
                }
            });
        });

        return obj;
    }

    listenersButtons() {
        let obj = this;

        obj.settings.buttons.forEach(function (button) {
            $('body').on('collapsible.click', button.el, function (event, button) {
                obj.data.isHidden = !obj.data.isHidden;

                if (button instanceof CollapsibleButton) {
                    button.setState(obj.data.isHidden).setLabel();
                }

                obj.stateChange();
            });
        });

        return obj;
    }

    listenersBeforeHidden() {
        let obj = this;

        $(obj.el).on('collapsible.beforeHidden', function () {
            obj.data.events.beforeHidden.forEach(function (callback) {
                if (typeof callback === 'function') {
                    callback.call(obj);
                }
            });
        });

        return obj;
    }

    listenersHidden() {
        let obj = this;

        $(obj.el).on('collapsible.hidden', function () {
            obj.data.events.hidden.forEach(function (callback) {
                if (typeof callback === 'function') {
                    callback.call(obj);
                }
            });
        });

        return obj;
    }

    listenersVisible() {
        let obj = this;

        $(obj.el).on('collapsible.visible', function () {
            obj.data.events.visible.forEach(function (callback) {
                if (typeof callback === 'function') {
                    callback.call(obj);
                }
            });
        });

        return obj;
    }

    listenersScroll() {
        let obj = this;
        let lastScrollTop = $(window).scrollTop();

        $(window).scroll(function () {
            if (obj.data.isHidden || !obj.settings.stickyButton) {
                return;
            }

            let scrollTop = $(window).scrollTop();
            let isScrollingUp = scrollTop > lastScrollTop;

            if (isScrollingUp) {
                if (obj.shouldUnstickButton()) {
                    obj.unstickButton();
                }
            } else {
                if (obj.shouldStickButton()) {
                    obj.stickButton();
                }
            }

            // For Mobile or negative scrolling
            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        });
    }

    onInitialized() {
        return this.stateChange();
    }

    stateChange() {
        let obj = this;

        if (obj.data.isHidden) {
            $(obj.el).trigger('collapsible.beforeHidden', obj);
            $(obj.el).trigger('collapsible.hidden', obj);
        } else {
            $(obj.el).trigger('collapsible.beforeVisible', obj);
            $(obj.el).trigger('collapsible.visible', obj);
        }
    }

    scrollIntoView(options) {
        let obj = this;
        if (obj.settings.scrollIntoView) {
            obj.el.scrollIntoView(options);
        }
    }

    beforeHidden() {
        let obj = this;
        obj.scrollIntoView();
    }

    onHidden() {
        return this.hide();
    }

    onVisible() {
        return this.show();
    }

    shouldUnstickButton() {
        let obj = this;
        let windowScrollTop = $(window).scrollTop();
        let collapsibleHeight =
            $(obj.el).offset().top + $(obj.el).outerHeight() - window.innerHeight;

        return windowScrollTop >= collapsibleHeight;
    }

    shouldStickButton() {
        let obj = this;
        let windowScrollTop = $(window).scrollTop();
        let button = $(obj.settings.stickyButton.el);
        let buttonHeight = button.outerHeight();
        let collapsibleHeight =
            $(obj.el).offset().top + $(obj.el).outerHeight() - window.innerHeight;

        return windowScrollTop <= collapsibleHeight + buttonHeight && !button.hasClass('sticky');
    }

    unstickButton() {
        let obj = this;
        let button = $(obj.settings.stickyButton.el);

        button.removeClass('sticky');
        $(obj.el).height(obj.data.originalHeight);
    }

    stickButton() {
        let obj = this;
        let button = $(obj.settings.stickyButton.el);
        let buttonHeight = button.outerHeight();

        button.addClass('sticky');
        $(obj.el).height($(obj.el).height() + buttonHeight);
    }

    toggleButtonStick() {
        let obj = this;

        if (obj.shouldUnstickButton()) {
            obj.unstickButton();
        } else if (obj.shouldStickButton()) {
            obj.stickButton();
        }
    }

    show() {
        let obj = this;
        $(obj.el).removeClass(obj.settings.hidden.join(' '));

        setTimeout(function () {
            obj.data.originalHeight = $(obj.el).height();
        },500);

        if (obj.shouldUnstickButton()) {
            obj.unstickButton();
        }
    }

    hide() {
        let obj = this;
        $(obj.el).addClass(obj.settings.hidden.join(' '));
        $(obj.el).height(obj.data.originalHeight);
    }
}

window.Collapsible = Collapsible;
